import development from './environment/development';
import production from './environment/production';
import uat from './environment/uat';
import testing from './environment/testing';
import testing2 from './environment/testing2';

const configs = {
	development,
	production,
	uat,
	testing,
	testing2
};

export default configs[process.env.NODE_ENV] || configs.development;
